import type { ThemeColorType } from '@capsule/consumer-design-system';
import { ButtonWithLinkStyle } from '@capsule/consumer-design-system';

import styled from 'styled-components';

export const MedicationsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.s3};
  padding: 0;
  margin: 0;
  list-style: none;
  margin-right: ${({ theme }) => theme.space.s3};
  margin-top: ${({ theme }) => theme.space.s5};
`;

export const LinkWithIcon = styled(ButtonWithLinkStyle)<{ color?: ThemeColorType }>`
  margin: 2rem 0;
  color: ${props => (props.color ? props.theme.colors[props.color] : props.theme.colors.capsuleBlue50)};
`;
